import React from "react";
import { useRecoilValue } from "recoil";
import PlayerProfileModal from "./PlayerProfileModal";
import FortuneWheelModal from "./FortuneWheelModal";
import { fortuneWheelModalStore } from "../stores/fortuneWheelModal";
import { playerPageStore } from "../stores/playerPage";
import PlayerPaymentsModal from "./PlayerPaymentsModal";
import PlayerDocumentModal from "./PlayerDocumentModal";
import PlayerSessionsModal from "./PlayerSessionsModal";
import PlayerGameLogModal from "./PlayerGameLogModal";
import PlayerModal from "./PlayerModal";
import GamesAddModal from "./GamesAddModal";
import GamesStatsModal from "./GamesStatsModal";
import GamesEditModal from "./GamesEditModal";
import GamesAutomanageModal from "./GamesAutomanageModal";
import GamesMetaTagsModal from "./GamesMetaTagsModal";
import StaffAddUserModal from "./StaffAddUserModal";
import StaffDetailModal from "./StaffDetailModal";
import StaffLogModal from "./StaffLogModal";
import StaffSessionsModal from "./StaffSessionsModal";
import DomainsEditDomainModal from "./DomainsEditDomainModal";
import DomainsAddDomainModal from "./DomainsAddDomainModal";
import ReportsAddCostsModal from "./ReportsAddCostsModal";
import ReportsAddSettlementsModal from "./ReportsAddSettlementsModal";
import BonusesAddModal from "./BonusesAddModal";
import BonusesEditModal from "./BonusesEditModal";
import ChatBanUserModal from "./ChatBanUserModal";
import { paymentStore } from "../stores/payments";
import { documentStore } from "../stores/document";
import { playerSessionsModalStore } from "../stores/playerSessionsModal";
import { playerGameLogStore } from "../stores/playerGameLog";
import { playerModalStore } from "../stores/playerModal";
import { gamesAddModalStore } from "../stores/gamesAddModal";
import { gamesStatsModalStore } from "../stores/gamesStatsModal";
import { gamesEditModalStore } from "../stores/gamesEditModal";
import { gamesAutoManageModalStore } from "../stores/gamesAutomanageModal";
import { staffAddModalStore } from "../stores/staffAddModal";
import { staffDetailModalStore } from "../stores/staffDetailModal";
import { staffLogModalStore } from "../stores/staffLogModal";
import { staffSessionsModalStore } from "../stores/staffSessionsModal";
import { domainsEditModalStore } from "../stores/domainsEditModal";
import { domainsAddModalStore } from "../stores/domainsAddModal";
import { reportsAddCostsModalStore, reportsAddSettlementsModalStore } from "../stores/reports";
import { bonusesAddModalStore } from "../stores/bonusesAddModal";
import { bonusesEditModalStore } from "../stores/bonusesEditModal";
import { chatBanUserModalStore } from "../stores/chatBanUserModal";
import BadgesAddModal from "./BadgesAddModal";
import BadgesEditModal from "./BadgesEditModal";
import BannersAnalyticsInfoModal from "./BannersAnalyticsInfoModal";
import MenuBannersAnalyticsInfoModal from "./MenuBannersAnalyticsInfoModal";
import { analyticsBannerInfoModalStore, analyticsMenuBannerInfoModalStore } from "../stores/analyticsBanners";
import { badgesAddModalStore } from "../stores/badgesAddModal";
import { badgesEditModalStore } from "../stores/badgesEditModal";
import BannersAddModal from "./BannersAddModal";
import PersonalPromotionsFormModal from "./PersonalPromotionsFormModal";
import { bannersAddModalStore } from "../stores/bannersAddModal";
import BannersEditModal from "./BannersEditModal";
import { bannersEditModalStore } from "../stores/bannersEditModal";
import HomeBannersAddModal from "./HomeBannersAddModal";
import { homeBannersAddModalStore } from "../stores/homeBannersAddModal";
import HomeBannersEditModal from "./HomeBannersEditModal";
import { homeBannersEditModalStore } from "../stores/homeBannersEditModal";
import AuthBannerSettingsModal from "./AuthBannerSettingsModal";
import { authBannerSettingsModalStore } from "../stores/authBannerSettingsModal";
import { personalPromotionsFormModalStore } from "../stores/personalPromotions";
import { tournamentsAddModalStore } from "../stores/tournamentsAddModal";
import TournamentsAddModal from "./TournamentsAddModal";
import { tournamentsEditModalStore } from "../stores/tournamentsEditModal";
import TournamentsEditModal from "./TournamentsEditModal";
import BlackListWithdrawalsAddModal from "./BlackListWithdrawalsAddModal";
import { blackListWithdrawalsAddModalStore } from "../stores/blackListWithdrawalsAddModal";
import { blackListWithdrawalsEditModalStore } from "../stores/blackListWithdrawalsEditModal";
import BlackListWithdrawalsEditModal from "./BlackListWithdrawalsEditModal";
import { whiteListPlayersWithdrawalsAddModalStore } from "../stores/whiteListPlayersWithdrawalsAddModal";
import WhiteListPlayerWithdrawalsAddModal from "./WhiteListPlayersWithdrawalsAddModal";
import { whiteListPlayersWithdrawalsEditModalStore } from "../stores/whiteListPlayersWithdrawalsEditModal";
import WhiteListPlayersWithdrawalsEditModal from "./WhiteListPlayersWithdrawalsEditModal";
import { tournamentsBannersAddModalStore } from "../stores/tournamentsBannersAddModal";
import TournamentsBannersAddModal from "./TournamentsBannersAddModal";
import { tournamentsBannersEditModalStore } from "../stores/tournamentsBannersEditModal";
import TournamentsBannersEditModal from "./TournamentsBannersEditModal";
import { promoBannersAddModalStore } from "../stores/promoBannersAddModal";
import PromoBannersAddModal from "./PromoBannersAddModal";
import { promoBannersEditModalStore } from "../stores/promoBannersEditModal";
import PromoBannersEditModal from "./PromoBannersEditModal";
import { chatPinnedAddModalStore } from "../stores/chatPinnedAddModal";
import ChatPinnedAddModal from "./ChatPinnedAddModal";
import { chatPinnedEditModalStore } from "../stores/chatPinnedEditModal";
import ChatPinnedEditModal from "./ChatPinnedEditModal";
import { gameDetailLogModalStore } from "../stores/gameDetailLogModal";
import GameDetailLogModal from "./GameDetailLogModal";
import { promotionAddModalStore } from "../stores/promotionAddModal";
import PromotionAddModal from "./PromotionAddModal";
import { promotionEditModalStore } from "../stores/promotionEditModal";
import PromotionEditModal from "./PromotionEditModal";
import { promotionConfigModalStore } from "../stores/promotionConfigModal";
import PromotionConfigModal from "./PromotionConfigModal";
import { walletPromotionAddModalStore } from "../stores/walletPromotionAddModal";
import WalletPromotionAddModal from "./WalletPromotionAddModal";
import { walletPromotionEditModalStore } from "../stores/walletPromotionEditModal";
import WalletPromotionEditModal from "./WalletPromotionEditModal";
import WalletGroupsEditModal from "./WalletGroupsEditModal";
import { walletGroupsEditModalStore } from "../stores/walletGroupsEditModal";
import DepositLadderFormModal from "./DepositLadderFormModal";
import { depositLadderFormStore } from "../stores/depositLadder";
import { tgBotsAddModalStore } from "../stores/tgBotsAddModal";
import TgBotsAddModal from "./TgBotsAddModal";
import { tgBotsEditModalStore } from "../stores/tgBotsEditModal";
import TgBotsEditModal from "./TgBotsEditModal";
import { tgBotsRotationStore } from "../stores/tgBotsRotation";
import TgBotsRotationModal from "./TgBotsRotationModal";
import { providerEditModalStore } from "../stores/providerEditModal";
import ProviderEditModal from "./ProviderEditModal";
import { clientEditModalStore } from "../stores/clientEditModal";
import ClientEditModal from "./ClientEditModal";
import { providerAddModalStore } from "../stores/providerAddModal";
import ProviderAddModal from "./ProviderAddModal";
import GamesAllEditModal from "./GamesAllEditModal";
import { gamesAllEditModalStore } from "../stores/gamesAllEditModal";
import { brandLicensesAddModalStore } from "../stores/brandLicensesAddModal";
import { brandLicensesEditModalStore } from "../stores/brandLicensesEditModal";
import BrandLicensesAddModal from "./BrandLicensesAddModal";
import BrandLicensesEditModal from "./BrandLicensesEditModal";
import { playerRulesAddModalStore } from "../stores/playerRulesAddModal";
import PlayerRulesAddModal from "./PlayerRulesAddModal";
import { playerRulesEditModalStore } from "../stores/playerRulesEditModal";
import PlayerRulesEditModal from "./PlayerRulesEditModal";
import { notificationsAddModalStore } from "../stores/notificationsAddModal";
import { notificationsEditModalStore } from "../stores/notificationsEditModal";
import { notificationsStatsModalStore } from "../stores/notificationsStatsModal";
import { notificationsRepeatModalStore } from "../stores/notificationsRepeatModal";
import { notificationTagsStore } from "../stores/notificationTags";
import NotificationModal from "./NotificationModal";
import NotificationsStatsModal from "./NotificationsStatsModal";
import NotificationRepeatModal from "./NotificationRepeatModal";
import NotificationTagsModal from "./NotificationTagsModal";
import { webhookBroadcastModalStore } from "../stores/webhookBroadcastModal";
import { webhookPresetModalStore } from "../stores/webhookPresetModal";
import { webhookBroadcastStatsModalStore } from "../stores/webhookBroadcastStatsModal";
import WebhookBroadcastModal from "./WebhookBroadcastModal";
import WebhookPresetModal from "./WebhookPresetModal";
import WebhookBroadcastStatsModal from "./WebhookBroadcastStatsModal";
import { groupEditModalStore } from "../stores/groupEditModal";
import GroupEditModal from "./GroupEditModal";
import { groupAddModalStore } from "../stores/groupAddModal";
import GroupAddModal from "./GroupAddModal";
import { playerBanAddModalStore } from "../stores/playerBanAddModal";
import playerBan from "./PlayerBan";
import PlayerBanAddModal from "./PlayerBanAddModal";
import PlayerBanEditModal from "./PlayerBanEditModal";
import { playerBanEditModalStore } from "../stores/playerBanEditModal";
import { playerHidePaywayStore } from "../stores/playerHidePayway";
import PlayerHidePaywayAddModal from "./PlayerHidePaywayAddModal";
import { playerHidePaywayAddModalStore } from "../stores/playerHidePaywayAddModal";
import { playerHidePaywayEditModalStore } from "../stores/playerHidePaywayEditModal";
import PlayerHidePaywayEditModal from "./PlayerHidePaywayEditModal";
import { gamesMetaTagsStore } from "../stores/gamesTagsModal";
import { achievementAddModalStore } from "../stores/achievementAddModal";
import { achievementEditModalStore } from "../stores/achievementEditModal";
import { achievementCategoryAddModalStore } from "../stores/achievementCategoryAddModal";
import { achievementCategoryEditModalStore } from "../stores/achievementCategoryEditModal";
import AchievementAddModal from "./AchievementAddModal";
import AchievementEditModal from "./AchievementEditModal";
import AchievementCategoryAddModal from "./AchievementCategoryAddModal";
import AchievementCategoryEditModal from "./AchievementCategoryEditModal";
import { prizeAddModalStore } from "../stores/prizeAddModal";
import PrizeAddModal from "./PrizeAddModal";
import PrizeEditModal from "./PrizeEditModal";
import { prizeEditModalStore } from "../stores/prizeEditModal";
import { chestPrizeAddModalStore } from "../stores/chestPrizeAddModal";
import { chestPrizeEditModalStore } from "../stores/chestPrizeEditModal";
import ChestPrizeAddModal from "./ChestPrizeAddModal";
import ChestPrizeEditModal from "./ChestPrizeEditModal";
import PrizeModalSettings from "./PrizeModalSettings";
import { prizeSettingsModalStore } from "../stores/prizeSettingsModal";
import { gamesSweepstakesModalStore } from "../stores/gamesSweepstakesModal";
import GamesSweepstakesModal from "./GamesSweepstakesModal";

const ModalsManager = ({ styles, doRoute, Interface }) => {
	const fortuneWheelModal = useRecoilValue(fortuneWheelModalStore);
	const playerPageModal = useRecoilValue(playerPageStore);
	const payments = useRecoilValue(paymentStore);
	const document = useRecoilValue(documentStore);
	const playerSessions = useRecoilValue(playerSessionsModalStore);
	const playerGameLog = useRecoilValue(playerGameLogStore);
	const playerModal = useRecoilValue(playerModalStore);
	const gamesAddModal = useRecoilValue(gamesAddModalStore);
	const gamesStatsModal = useRecoilValue(gamesStatsModalStore);
	const gamesEditModal = useRecoilValue(gamesEditModalStore);
	const gamesAutoManageModal = useRecoilValue(gamesAutoManageModalStore);
	const gamesMetaTagsModal = useRecoilValue(gamesMetaTagsStore);
	const gamesSweepstakesModal = useRecoilValue(gamesSweepstakesModalStore);
	const staffAddModal = useRecoilValue(staffAddModalStore);
	const staffDetailModal = useRecoilValue(staffDetailModalStore);
	const staffLog = useRecoilValue(staffLogModalStore);
	const staffSessions = useRecoilValue(staffSessionsModalStore);
	const domainsEditModal = useRecoilValue(domainsEditModalStore);
	const domainsAddModal = useRecoilValue(domainsAddModalStore);
	const reportsAddCostsModal = useRecoilValue(reportsAddCostsModalStore);
	const reportsAddSettlementsModal = useRecoilValue(reportsAddSettlementsModalStore);
	const bonusesAddModal = useRecoilValue(bonusesAddModalStore);
	const bonusesEditModal = useRecoilValue(bonusesEditModalStore);
	const chatBanUserModal = useRecoilValue(chatBanUserModalStore);
	const badgesAddModal = useRecoilValue(badgesAddModalStore);
	const badgesEditModal = useRecoilValue(badgesEditModalStore);
	const bannersAddModal = useRecoilValue(bannersAddModalStore);
	const bannersEditModal = useRecoilValue(bannersEditModalStore);
	const homeBannersAddModal = useRecoilValue(homeBannersAddModalStore);
	const homeBannersEditModal = useRecoilValue(homeBannersEditModalStore);
	const authBannerSettingsModal = useRecoilValue(authBannerSettingsModalStore);
	const bannerInfoModal = useRecoilValue(analyticsBannerInfoModalStore);
	const menuBannerInfoModal = useRecoilValue(analyticsMenuBannerInfoModalStore);
	const tournamentsAddModal = useRecoilValue(tournamentsAddModalStore);
	const tournamentsEditModal = useRecoilValue(tournamentsEditModalStore);
	const blackListWithdrawalsAddModal = useRecoilValue(blackListWithdrawalsAddModalStore);
	const blackListWithdrawalsEditModal = useRecoilValue(blackListWithdrawalsEditModalStore);
	const whiteListPlayersWithdrawalsAddModal = useRecoilValue(whiteListPlayersWithdrawalsAddModalStore);
	const whiteListPlayersWithdrawalsEditModal = useRecoilValue(whiteListPlayersWithdrawalsEditModalStore);
	const tournamentsBannersAddModal = useRecoilValue(tournamentsBannersAddModalStore);
	const tournamentsBannersEditModal = useRecoilValue(tournamentsBannersEditModalStore);
	const promoBannersAddModal = useRecoilValue(promoBannersAddModalStore);
	const promoBannersEditModal = useRecoilValue(promoBannersEditModalStore);
	const chatPinnedAddModal = useRecoilValue(chatPinnedAddModalStore);
	const chatPinnedEditModal = useRecoilValue(chatPinnedEditModalStore);
	const promotionAddModal = useRecoilValue(promotionAddModalStore);
	const promotionEditModal = useRecoilValue(promotionEditModalStore);
	const promotionConfigModal = useRecoilValue(promotionConfigModalStore);
	const walletPromotionAddModal = useRecoilValue(walletPromotionAddModalStore);
	const walletPromotionEditModal = useRecoilValue(walletPromotionEditModalStore);
	const walletGroupsEditModal = useRecoilValue(walletGroupsEditModalStore);
	const depositLadderForm = useRecoilValue(depositLadderFormStore);
	const tgBotsAddModal = useRecoilValue(tgBotsAddModalStore);
	const tgBotsEditModal = useRecoilValue(tgBotsEditModalStore);
	const tgBotsRotation = useRecoilValue(tgBotsRotationStore);
	const gameDetailLogModal = useRecoilValue(gameDetailLogModalStore);
	const providerEditModal = useRecoilValue(providerEditModalStore);
	const providerAddModal = useRecoilValue(providerAddModalStore);
	const clientEditModal = useRecoilValue(clientEditModalStore);
	const gamesEditAll = useRecoilValue(gamesAllEditModalStore);
	const brandLicensesAddModal = useRecoilValue(brandLicensesAddModalStore);
	const personalPromotionsFormModal = useRecoilValue(personalPromotionsFormModalStore);
	const brandLicensesEditModal = useRecoilValue(brandLicensesEditModalStore);
	const playerRulesAddModal = useRecoilValue(playerRulesAddModalStore);
	const playerRulesEditModal = useRecoilValue(playerRulesEditModalStore);
	const notificationsAddModal = useRecoilValue(notificationsAddModalStore);
	const notificationsEditModal = useRecoilValue(notificationsEditModalStore);
	const notificationsStatsModal = useRecoilValue(notificationsStatsModalStore);
	const notificationsRepeatModal = useRecoilValue(notificationsRepeatModalStore);
	const notificationTags = useRecoilValue(notificationTagsStore);
	const webhookBroadcastModal = useRecoilValue(webhookBroadcastModalStore);
	const webhookPresetModal = useRecoilValue(webhookPresetModalStore);
	const webhookBroadcastStatsModal = useRecoilValue(webhookBroadcastStatsModalStore);

	const groupEditModal = useRecoilValue(groupEditModalStore);
	const groupAddModal = useRecoilValue(groupAddModalStore);

	const playerBanAddModal = useRecoilValue(playerBanAddModalStore);
	const playerBanEditModal = useRecoilValue(playerBanEditModalStore);

	const playerHidePaywayEditModal = useRecoilValue(playerHidePaywayEditModalStore);
	const playerHidePaywayAddModal = useRecoilValue(playerHidePaywayAddModalStore);

	const achievementAddModal = useRecoilValue(achievementAddModalStore);
	const achievementEditModal = useRecoilValue(achievementEditModalStore);

	const achievementCategoryAddModal = useRecoilValue(achievementCategoryAddModalStore);
	const achievementCategoryEditModal = useRecoilValue(achievementCategoryEditModalStore);

	const prizeAddModal = useRecoilValue(prizeAddModalStore);
	const prizeEditModal = useRecoilValue(prizeEditModalStore);
	const chestPrizeAddModal = useRecoilValue(chestPrizeAddModalStore);
	const chestPrizeEditModal = useRecoilValue(chestPrizeEditModalStore);
	const prizeSettingsModal = useRecoilValue(prizeSettingsModalStore);

	return (
		<>
			{fortuneWheelModal.show && <FortuneWheelModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerPageModal?.show && <PlayerProfileModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{payments.show && <PlayerPaymentsModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{document.show && <PlayerDocumentModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerSessions.show && <PlayerSessionsModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerGameLog.show && <PlayerGameLogModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{gameDetailLogModal.show && <GameDetailLogModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerModal.show > 0 && <PlayerModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{gamesAddModal.show && <GamesAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{gamesStatsModal.show && <GamesStatsModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{gamesEditModal.show && <GamesEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{gamesAutoManageModal.show && <GamesAutomanageModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{gamesMetaTagsModal.show && <GamesMetaTagsModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{gamesSweepstakesModal.show && <GamesSweepstakesModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{staffAddModal.show && <StaffAddUserModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{staffDetailModal.show && <StaffDetailModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{staffLog.show && <StaffLogModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{staffSessions.show && <StaffSessionsModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{domainsEditModal.show && <DomainsEditDomainModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{domainsAddModal.show && <DomainsAddDomainModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{reportsAddCostsModal.show && <ReportsAddCostsModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{reportsAddSettlementsModal.show && <ReportsAddSettlementsModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{bonusesAddModal.show && <BonusesAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{bonusesEditModal.show && <BonusesEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{chatBanUserModal.show && <ChatBanUserModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{badgesAddModal.show && <BadgesAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{badgesEditModal.show && <BadgesEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{bannersAddModal.show && <BannersAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{bannersEditModal.show && <BannersEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{homeBannersAddModal.show && <HomeBannersAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{homeBannersEditModal.show && <HomeBannersEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{authBannerSettingsModal.show && <AuthBannerSettingsModal Interface={Interface} />}
			{bannerInfoModal.show && <BannersAnalyticsInfoModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{menuBannerInfoModal.show && <MenuBannersAnalyticsInfoModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{tournamentsAddModal.show && <TournamentsAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{tournamentsEditModal.show && <TournamentsEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{blackListWithdrawalsAddModal.show && <BlackListWithdrawalsAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{blackListWithdrawalsEditModal.show && <BlackListWithdrawalsEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{whiteListPlayersWithdrawalsAddModal.show && <WhiteListPlayerWithdrawalsAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{whiteListPlayersWithdrawalsEditModal.show && <WhiteListPlayersWithdrawalsEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{tournamentsBannersAddModal.show && <TournamentsBannersAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{tournamentsBannersEditModal.show && <TournamentsBannersEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{promoBannersAddModal.show && <PromoBannersAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{promoBannersEditModal.show && <PromoBannersEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{chatPinnedAddModal.show && <ChatPinnedAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{chatPinnedEditModal.show && <ChatPinnedEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{promotionAddModal.show && <PromotionAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{promotionEditModal.show && <PromotionEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{promotionConfigModal.show && <PromotionConfigModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{walletPromotionAddModal.show && <WalletPromotionAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{walletPromotionEditModal.show && <WalletPromotionEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{walletGroupsEditModal.show && <WalletGroupsEditModal Interface={Interface} />}
			{depositLadderForm.show && <DepositLadderFormModal Interface={Interface} />}
			{tgBotsAddModal.show && <TgBotsAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{tgBotsEditModal.show && <TgBotsEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{tgBotsRotation.show && <TgBotsRotationModal Interface={Interface} />}
			{providerEditModal.show && <ProviderEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{clientEditModal.show && <ClientEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{providerAddModal.show && <ProviderAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{gamesEditAll.show && <GamesAllEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{brandLicensesAddModal.show && <BrandLicensesAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{brandLicensesEditModal.show && <BrandLicensesEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{personalPromotionsFormModal.isOpen && <PersonalPromotionsFormModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerRulesAddModal.show && <PlayerRulesAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerRulesEditModal.show && <PlayerRulesEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{notificationsAddModal.show && <NotificationModal Interface={Interface} mode="add" />}
			{notificationsEditModal.show && <NotificationModal Interface={Interface} mode="edit" />}
			{notificationsStatsModal.show && <NotificationsStatsModal Interface={Interface} />}
			{notificationsRepeatModal.show && <NotificationRepeatModal Interface={Interface} />}
			{notificationTags.show && <NotificationTagsModal Interface={Interface} />}
			{webhookBroadcastModal.show && <WebhookBroadcastModal Interface={Interface} />}
			{webhookPresetModal.show && <WebhookPresetModal Interface={Interface} />}
			{webhookBroadcastStatsModal.show && <WebhookBroadcastStatsModal Interface={Interface} />}
			{groupEditModal.show && <GroupEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{groupAddModal.show && <GroupAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerBanAddModal.show && <PlayerBanAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerBanEditModal.show && <PlayerBanEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerHidePaywayAddModal.show && <PlayerHidePaywayAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{playerHidePaywayEditModal.show && <PlayerHidePaywayEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{achievementAddModal.show && <AchievementAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{achievementEditModal.show && <AchievementEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{achievementCategoryAddModal.show && <AchievementCategoryAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{achievementCategoryEditModal.show && <AchievementCategoryEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{prizeAddModal.show && <PrizeAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{prizeEditModal.show && <PrizeEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{chestPrizeAddModal.show && <ChestPrizeAddModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{chestPrizeEditModal.show && <ChestPrizeEditModal styles={styles} doRoute={doRoute} Interface={Interface} />}
			{prizeSettingsModal.show && <PrizeModalSettings styles={styles} doRoute={doRoute} Interface={Interface} />}
		</>
	);
};

export default ModalsManager;
